import React from 'react';
import { ThemeProvider } from './theme';
import { Footer, Header, ThemeToggle } from './layout';
import { HeroSection } from './sections/HeroSection/HeroSection';
import { OurApproachSection } from './sections/OurApproachSection';
import { ParadigmSection } from './sections/ParadigmSection';
import { CTASection } from './sections/CTASection';
import './theme/globals.css';

function MainContent() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <ThemeToggle />
      <main>
        <HeroSection />
        <OurApproachSection />
        <ParadigmSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export function CurrentApp() {
  return (
    <ThemeProvider defaultTheme="light">
      <MainContent />
    </ThemeProvider>
  );
}

export default CurrentApp;
